import { useLang } from "@/lib/i18n";
import PolicyPage from "@/components/PolicyPage";

export default function ReturnsPolicy() {
  const { t } = useLang();
  return (
    <PolicyPage
      testid="returns-policy"
      title={t.returns.title}
      intro={t.returns.intro}
      sections={[
        { title: t.returns.r1Title, body: t.returns.r1Body, placeholder: t.returns.placeholder },
        { title: t.returns.r2Title, body: t.returns.r2Body },
        { title: t.returns.r3Title, body: t.returns.r3Body, placeholder: t.returns.placeholder },
        { title: t.returns.exchTitle, body: t.returns.exchBody },
        { title: t.returns.noteTitle, body: t.returns.noteBody },
      ]}
    />
  );
}
